import React from 'react';

import { MessageBox } from 'react-chat-elements';
import PropTypes from 'prop-types';

export default function FileMessage({ message }) {
  return (
    <MessageBox
      position={message.position}
      type="file"
      text={message.text}
      data={message.data}
      onClick={() => {
        window.open(message.data.uri);
      }}
    />
  );
}

FileMessage.propTypes = {
  message: PropTypes.object.isRequired,
};
